// Chrome Co. sale engine: keeps banners, prices and countdowns in sync with the
// automatic discounts set in Shopify admin (same dates, same percentages).
(function () {
  var DEALS = [
    { name: 'Black Friday', pct: 35, start: 1793148900, end: 1796191199 },
    { name: 'Christmas Sale', pct: 25, start: 1796191200, end: 1797573599 }
  ];
  function active() {
    var t = Date.now() / 1000;
    for (var i = 0; i < DEALS.length; i++) if (t >= DEALS[i].start && t <= DEALS[i].end) return DEALS[i];
    return null;
  }
  var fmt = window.CC_MONEY || '${{amount}}';
  function money(c) {
    var v = (c / 100).toFixed(2), p = v.split('.'), w = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (/no_decimals/.test(k)) return w;
      if (k.indexOf('comma') > -1) return w.replace(/,/g, '.') + ',' + p[1];
      return w + '.' + p[1];
    });
  }
  function salePrice(c, d) { return d ? c - Math.round(c * d.pct / 100) : c; }
  window.CCDeal = { active: active, money: money, salePrice: salePrice };

  function render() {
    var d = active();
    document.querySelectorAll('[data-cc-when-deal]').forEach(function (el) { el.hidden = !d; });
    if (d) {
      document.querySelectorAll('[data-cc-deal-name]').forEach(function (el) { el.textContent = d.name; });
      document.querySelectorAll('[data-cc-deal-pct]').forEach(function (el) { el.textContent = d.pct; });
    }
    document.querySelectorAll('.cc-price[data-cents]').forEach(function (el) {
      var c = +el.dataset.cents, from = el.dataset.from ? 'From ' : '';
      el.innerHTML = d
        ? '<span class="cc-now">' + from + money(salePrice(c, d)) + '</span><s class="cc-was">' + money(c) + '</s><span class="cc-off">-' + d.pct + '%</span>'
        : '<span class="cc-now">' + from + money(c) + '</span>';
    });
    return d;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var d = active();
    if (!d) { render(); return; }
    var s = Math.max(0, Math.floor(d.end - Date.now() / 1000));
    var dd = Math.floor(s / 86400), hh = Math.floor(s % 86400 / 3600), mm = Math.floor(s % 3600 / 60), ss = s % 60;
    document.querySelectorAll('[data-cc-countdown]').forEach(function (el) {
      el.textContent = dd > 0 ? dd + 'd ' + pad(hh) + 'h ' + pad(mm) + 'm' : pad(hh) + 'h ' + pad(mm) + 'm ' + pad(ss) + 's';
    });
    var map = { d: dd, h: hh, m: mm, s: ss };
    document.querySelectorAll('[data-cc-cd]').forEach(function (el) { el.textContent = pad(map[el.dataset.ccCd]); });
    if (s === 0) render();
  }

  // Welcome intro: shown once per visitor, never on cart pages
  function welcome() {
    var w = document.getElementById('ccWelcome');
    var toast = document.getElementById('ccToast');
    if (/customer_posted=true/.test(location.search) && toast) {
      toast.hidden = false; setTimeout(function () { toast.hidden = true; }, 5000);
      try { localStorage.setItem('cc_welcome_v1', '1'); } catch (e) {}
      return;
    }
    if (!w || document.body.classList.contains('template-cart')) return;
    var seen = false;
    try { seen = localStorage.getItem('cc_welcome_v1') === '1'; } catch (e) {}
    if (seen) return;
    var last;
    function close() {
      w.classList.remove('on');
      setTimeout(function () { w.hidden = true; }, 300);
      document.removeEventListener('keydown', onKey);
      if (last) last.focus();
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    setTimeout(function () {
      try { localStorage.setItem('cc_welcome_v1', '1'); } catch (e) {}
      last = document.activeElement;
      w.hidden = false;
      requestAnimationFrame(function () { w.classList.add('on'); });
      document.addEventListener('keydown', onKey);
      var x = w.querySelector('.cc-wel-x'); if (x) x.focus();
    }, 1400);
    w.querySelectorAll('[data-cc-close]').forEach(function (b) { b.addEventListener('click', close); });
  }

  function start() { render(); tick(); setInterval(tick, 1000); welcome(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
